import { useResizeObserver } from '@mantine/hooks'
import { useCallback, useEffect, useState } from 'react'

import { hasHorizontalOverflow } from '@/utils/dom'

/**
 * Custom hook to detect horizontal overflow in a container
 * @param dependencies - Array of dependencies that should trigger re-check
 * @returns Object containing containerRef, hasOverflow state, and checkOverflow function
 */
export default function useHorizontalOverflow(dependencies: any[] = []) {
  const [containerRef, rect] = useResizeObserver()
  const [hasOverflow, setHasOverflow] = useState(false)

  const checkOverflow = useCallback(() => {
    if (containerRef.current) {
      const carouselContainer = containerRef.current.querySelector('.mantine-Carousel-container')
      if (carouselContainer) {
        const shouldShow = hasHorizontalOverflow(carouselContainer as HTMLElement)
        setHasOverflow(shouldShow)
      }
    }
  }, dependencies)

  useEffect(() => {
    checkOverflow()
  }, [rect, checkOverflow])

  return {
    containerRef,
    hasOverflow,
    checkOverflow,
  }
}
